import { createAction } from "@reduxjs/toolkit";

const addRetailersListAsyncAction = createAction("ADD_RETAILERS_LIST_ASYNC");

export default addRetailersListAsyncAction;
